import { render, staticRenderFns } from "./PmtaEmailTests.vue?vue&type=template&id=71624a0e&scoped=true"
import script from "./PmtaEmailTests.vue?vue&type=script&lang=js"
export * from "./PmtaEmailTests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71624a0e",
  null
  
)

export default component.exports